const axios = require('axios');

(() => {
  const selectBarbecuePlans = '.select-customer-barbecue-plans'
  const selectOnlyBarbecueArea = '.select-customer-only-barbecue-area'
  const selectBarbecuePlan = '.select-customer-barbecue-plan'
  const barbecuePlans = '.customer_barbecue_plans'
  const barbecueBringIn = '.customer_barbecue_bring'
  const buttonToOptionsPage = '.move-barbecue-option-page-button'
  const onlyBarbecueAreaNextPage = '.only-barbecue-area-type-next-page'
  const barbecuePlanTypeNextPage = '.barbecue-plan-type-next-page'
  const newPath = process.env.JS_BASE_URL + 'customer/barbecue/barbecue_plan/new'
  const showDisabledBtn = '.show-disabled-button'
  const showActiveBtn = '.show-active-button'

  const init = () => {
    if (location.href.indexOf('customer/barbecue/barbecue_plan') < 1 ) {
      return
    }
    $(buttonToOptionsPage).prop('disabled', true);
    $(barbecuePlans).hide();
    $(barbecueBringIn).hide();
    $(onlyBarbecueAreaNextPage).hide();
    $(showDisabledBtn).show();
    $(showActiveBtn).hide();
    $('body')
      .on('change', selectBarbecuePlan, changePrice)
      .on('click', selectBarbecuePlans, showBarbecuePlans)
      .on('click', selectOnlyBarbecueArea, disabledFalseNextButton);
    showBarbecuePlans();
    disabledFalseNextButton();
  }

  const changePrice = () => {
    const token = $('meta[name="csrf-token"]').attr('content');
    axios({
      url: process.env.JS_BASE_URL + 'customer/barbecue/barbecue_plan/change',
      method: 'POST',
      data: $('form').serialize(),
      withCredentials: true,
      headers: {'X-CSRF-Token': token}
    })
    .then(response => {
      $('.plan-block-right').html(response['data'])
    })
    .catch(error => {
      console.log(error);
      return error;
    })

  }

  const showBarbecuePlans = () => {
    changePrice();
    if (!$(selectBarbecuePlans).prop('checked')) {
      return;
    }
    $(barbecuePlans).fadeIn();
    $(barbecueBringIn).fadeOut();
    $(buttonToOptionsPage).prop('disabled', false);
    $(barbecuePlanTypeNextPage).show();
    $(onlyBarbecueAreaNextPage).hide();
    $(showDisabledBtn).hide();
    $(showActiveBtn).show();
  }

  const disabledFalseNextButton = () => {
    changePrice();
    if (!$(selectOnlyBarbecueArea).prop('checked')) {
      return;
    }
    $(buttonToOptionsPage).prop('disabled', false);
    $(barbecuePlans).fadeOut();
    $(barbecueBringIn).fadeIn();
    $(barbecuePlanTypeNextPage).hide();
    $(onlyBarbecueAreaNextPage).show();
    $(showDisabledBtn).hide();
    $(showActiveBtn).show();
  }
  $(init);
})();

